import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { svgSprite, Portal } from '../../../../hybrid/wrappers';
import UserData from '../UserData/UserData';
import UserStats from '../UserStats/UserStats';
import ProgressBlock from '../ProgressBlock/ProgressBlock';
import UserVolumes from '../UserVolumes/UserVolumes';
import { t } from '../../../../common/components/T';
import { useWidgetTranslates } from '../../../../common/utils/utils';
import Loader from '../../../plug/Loader/Loader';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import Skeleton from '../../../plug/Skeleton/Skeleton';
import { userSidebarSkeleton } from '../../../plug/Skeleton/components/patterns';
import css from './UserModalInfo.module.scss';
import classNames from 'classnames';

const RenderData = ({ userData, trans }) => {
    return (
        <>
            <div className={css.userModalTopWrap}>
                <UserData trans={trans} data={{ ...userData, ...userData?.marketing_profile }} position={1} />
            </div>
            {userData.loaded !== false ||
            userData.new_partners_number ||
            userData.active_partners_number ||
            userData.children_number ||
            userData.children_count ||
            userData.partners_number ||
            userData.descendants_count ||
            userData.binary_partners ? (
                <UserStats data={{ ...userData, ...userData?.marketing_profile }} trans={trans} />
            ) : userData?.rankData ? (
                <Loader compStyles={{ loader: css.loader }} />
            ) : null}
            <div className={classNames(css.hr, css.hrMod)} />

            {userData?.rankData ? (
                <ProgressBlock rankData={userData.rankData || {}} trans={trans} />
            ) : userData.loaded === false && userData?.marketing_profile ? (
                <Loader compStyles={{ loader: css.loader }} />
            ) : null}

            <div className={css.hr} />

            {userData.loaded === false && !userData?.marketing_profile ? (
                <Loader compStyles={{ loader: css.loader }} />
            ) : (
                <div>
                    <UserVolumes data={userData} trans={trans} />
                </div>
            )}
            {userData.sponsor ? (
                <>
                    <div className={css.hr} />
                    <div className={css.userModalHeader}>
                        {/*{t('user_modal_sponsor_title', 'Ваш спонсор', 'widget', trans, 'userModal')}*/}
                        {t('user_modal_sponsor_titleSM', 'Спонсор', 'widget', trans, 'userModal')}
                    </div>
                    <div className={css.userModalTopWrap}>
                        <UserData
                            data={{
                                ...userData.sponsor,
                                ...userData.sponsor?.marketing_profile,
                                rankData: userData.sponsor?.marketing_profile?.rank ? {} : false
                            }}
                            trans={trans}
                            position={2}
                        />
                    </div>
                </>
            ) : userData.loaded === false && userData?.marketing_profile ? (
                <Loader compStyles={{ loader: css.loader }} />
            ) : null}
        </>
    );
};
const UserModalInfo = (props) => {
    const { userData, setShowUser, setUserData, closeHandler } = props;
    const [showUserInfo, setShowUserInfo] = useState(true);

    const trans = useWidgetTranslates('userModal');
    const widthDimensions = useWindowDimensions();

    const screenWidth = useMemo(() => widthDimensions < 576, [widthDimensions]);
    return (
        <Portal closeHandler={closeHandler} fullWidth={screenWidth} fullHeight={screenWidth} customClass='officePage modalTop'>
            <div
                style={showUserInfo ? { display: 'block' } : { display: 'none' }}
                className={showUserInfo ? css.userModalInfoContainerFixed : css.userModalInfoContainer}
            >
                <div className={css.userModalInfoWrap}>
                    <div
                        className={css.userModalClose}
                        onClick={() => {
                            setShowUserInfo(!showUserInfo);
                            setShowUser(false);
                            setUserData(false);
                        }}
                    >
                        {svgSprite('arrow-right', {
                            width: '20px',
                            height: '14px'
                        })}
                    </div>

                    <div className={classNames('custom-scroll', css.userModalInfoBlock)}>
                        <div className={css.userModalHeader}>
                            {t('user_modal_title', 'Выбранный пользователь', 'widget', trans, 'userModal')}
                        </div>
                        <Skeleton
                            pattern={userSidebarSkeleton}
                            wait={Boolean(userData && trans)}
                            Component={RenderData}
                            componentProps={{ ...props, trans }}
                        />
                    </div>
                </div>
            </div>
        </Portal>
    );
};
UserModalInfo.propTypes = {
    userData: PropTypes.object,
    setShowUser: PropTypes.func,
    setUserData: PropTypes.func,
    isAbsolute: PropTypes.bool,
    closeHandler: PropTypes.func,
    trans: PropTypes.object
};
export default UserModalInfo;
